export default function UserTransferIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 640 512"
      fill="currentColor"
      className="svg-inline--fa fa-user-transfer-alt"
      aria-hidden="true"
      focusable="false"
      role="img"
    >
      <path d="M224 256a128 128 0 1 0 0-256 128 128 0 0 0 0 256zm-45.5 48h91c70.7 0 128 57.3 128 128 0 8.8-7.2 16-16 16H67.5c-8.8 0-16-7.2-16-16 0-70.7 57.3-128 128-128zm325.4-19.3l-64-64c-10-10-27.3-2.9-27.3 11.3v32h-112c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h112v32c0 14.2 17.2 21.3 27.3 11.3l64-64c6.2-6.2 6.2-16.4 0-22.6z" />
    </svg>
  );
}
